// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"d974aeed","132":"0c6167da","168":"c4a4d504","209":"7286bd04","264":"3100754c","656":"3d5a71cc","760":"44919a9f","888":"3c9b54db","936":"686f250f","940":"51b286f0"}[chunkId] + ".chunk.js";
};